import { shallowMount } from "@vue/test-utils";
import SearchEncontesa from "@/components/core/SearchEncontesa";

describe("SearchEncontesa component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(SearchEncontesa);
  });

  it("Renders del component SearchEncontesa", () => {
    expect(wrapper).toBeDefined();
  });
});
